import { Container, Grid, Typography } from "@material-ui/core";
import Role from "../../assets/swipeImg/13.png";

import "./index.less";

const team = [
  {
    name: "Alexander",
    role: "Project Leader",
  },
  {
    name: "zoojoo",
    role: "Art Director",
  },
  {
    name: "Alexoo",
    role: "Smart Contract Engineer",
  },
  {
    name: "Joy",
    role: "Front end Engineer",
  },
  {
    name: "Ray",
    role: "Back end Engineer",
  },
  {
    name: "hulu",
    role: "Front end Engineer",
  },
  {
    name: "Jason",
    role: "Community operation",
  },
  {
    name: "BANANA",
    role: "UI desiger",
  },
];

export default function Team() {
  return (
    <div className="team">
      <Container maxWidth="lg">
        <Grid
          container
          spacing={4}
          alignContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} md={5} className="airdrop-desc">
            <Typography component="div" variant="h4" className="title">
              THE TEAM
            </Typography>
            <Typography component="div" variant="h6" className="sub-title">
              <span style={{ color: "#ffc938" }}>
                # We are firm believers of Web 3.0 and disciples of blockchain
                technologies.
              </span>
            </Typography>
            <Typography
              component="div"
              variant="h6"
              paragraph
              className="content"
            >
              {team.map((member, index) => {
                return (
                  <div className="member" key={index}>
                    <span style={{ color: "#ffc938" }}>{member.name}.</span>{" "}
                    {member.role}
                  </div>
                );
              })}
            </Typography>
          </Grid>
          <Grid item xs={12} md={5} className="tv-img">
            <img src={Role} width="100%" alt="" />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
